<template>
  <div class="security-options">
    <h2 class="title">Настройки безопасности</h2>
    <form @submit.prevent="saveOptions" class="form">
      <div v-for="(value, key) in editedOptions" :key="key" class="input-row" >
        <label v-if="key !== 'id'" class="label">{{ getLabel(key) }}:</label>
        <input v-if="key !== 'id'" v-model="editedOptions[key]" @input="markAsModified" :disabled="isSaving" class="input" />
      </div>
      <button :disabled="isSaving || !isModified" class="save-button">Сохранить</button>
    </form>
  </div>
</template>

<script>
import { ref, computed, watch,onMounted  } from 'vue';
import { useStore } from 'vuex';

export default {
  name: 'SecurityOptions',
  setup() {
    const store = useStore();
    const options = computed(() => store.state.apiStorage.admin.security);
    const editedOptions = ref(null); // Initialize as null

    onMounted(()=>{
      store.dispatch('apiStorage/getOptions',{model:'security',params:{}})
    })

    // Watch for changes in the options, and initialize editedOptions once options are available
    watch(options, (newOptions) => {
      if (newOptions) {
        editedOptions.value = { ...newOptions };
      }
    });

    const isSaving = ref(false);
    const isModified = ref(false);

    const markAsModified = () => {
      isModified.value = true;
    };

    const saveOptions = async () => {
      if (!isModified.value || isSaving.value) {
        return;
      }

      isSaving.value = true;

      try {
        // Make an API call to save the editedOptions
        await store.dispatch('apiStorage/updateOptions', {model:'security',form:editedOptions.value});
      } catch (error) {
        console.error('Error saving options:', error);
      } finally {
        isSaving.value = false;
      }
    };

    const getLabel = (key) => {
      const labels = {
        min_release_year: 'Минимальный год выпуска',
        min_year_passed: 'Минимальное количество лет владения',
        min_company_registration_year: 'Минимальный год регистрации компании',
      };
      return labels[key] || key;
    };

    return {
      editedOptions,
      isSaving,
      isModified,
      markAsModified,
      saveOptions,
      getLabel
    };
  },
};
</script>

<style scoped>
.security-options {
  padding: 20px;
}

.title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 10px;
}

.form {
/*  width: 300px;*/
}

.input-row {

  margin-bottom: 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.label {
  font-weight: bold;
}

.input {
  max-width: 250px;
  flex: 1;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  transition: border-color 0.2s;
}

.input:focus {
  outline: none;
  border-color: #007bff;
}

.save-button {
  margin-top: 15px;
  padding: 8px 12px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: bold;
  transition: background-color 0.2s;
}

.save-button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}
</style>
